<template>
	<li :class="!disabled ? 'color-bg' : ''">
		<router-link class="flex items-center pl-6 pr-4 pt-2 pb-2 mb-1" :to="to" :class="{ active: active }" v-if="!disabled">
			<div class="w-8">
				<font-awesome-icon :icon="[this.$props.faIconType, this.$props.faIconName]" class="w-5 h-5 pr-1 mr-2" size="lg" />
			</div>
			<div class="flex flex-grow justify-between">
				<p>
					{{ this.title }}
				</p>
				<div v-if="notificationCount > 0" style="text-align: center; background-color: red" class="justify-end rounded-full w-6">
					{{ notificationCount }}
				</div>
			</div>
		</router-link>
		<div class="flex items-center pl-6 pr-4 pt-2 pb-2 mb-1" v-else>
			<div class="w-8">
				<font-awesome-icon :icon="[this.$props.faIconType, this.$props.faIconName]" class="w-5 h-5 pr-1 mr-2 text-gray-600" size="lg" />
			</div>
			<div class="flex flex-grow justify-between text-gray-600">
				<p>
					{{ this.title }}
				</p>
				<div v-if="notificationCount > 0" style="text-align: center; background-color: red" class="justify-end rounded-full w-6">
					{{ notificationCount }}
				</div>
			</div>
		</div>
	</li>
</template>

<script>
export default {
	props: {
		link: {
			type: Object,
		},
		title: {
			type: String,
			required: true,
		},
		notificationCount: {
			type: Number,
			default: 0,
		},
		faIconType: {
			type: String,
			default: 'far',
		},
		faIconName: {
			type: String,
			default: 'circle',
		},
		active: {
			default: false,
		},
		disabled: {
			default: false,
		},
	},
	data() {
		return {
			to: this.$props.link,
		};
	},
};
</script>

<style lang="sass" scoped>
.active,.router-link-exact-active
	background-color: #0068B4
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)
	color: white

.color-bg
	border-radius: 0.25rem

	&:hover
		background-color: $sp_secondary_light
		color: white

li
	a
		border-radius: 0.25rem
		color: $sidebar_text
</style>
